import config from "../../config"
import RequestService from "../RequestService"

const fetchUsers = (successCallback, failureCallback) => {
  RequestService.get(`${config.backendUrl}/users`, successCallback, failureCallback)
}

export default fetchUsers;